var _style, _path, _path2, _linearGradient, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobiletogether(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "MobileTogether",
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.a{fill:#fff}.b{fill:#323638}\n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.3 28.8c0 15.7-12.8 28.5-28.5 28.5S.3 44.5.3 28.8 13.1.3 28.8.3s28.5 12.8 28.5 28.5z",
    fill: "#98cbfb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.8 9.4c-3.3 0-6.1 2.7-6.1 6v26.7c0 1.6.6 3.1 1.7 4.3 1.1 1.2 2.7 1.8 4.3 1.8h14.1c3.4 0 6.1-2.7 6.1-6V15.5c0-1.6-.6-3.1-1.7-4.3-1.2-1.2-2.7-1.8-4.3-1.8H21.8z"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "ID1",
    gradientUnits: "userSpaceOnUse",
    x1: 17.761,
    y1: 17.645,
    x2: 26.149,
    y2: 26.139
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.005,
    stopColor: "#c7e3fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.257,
    stopColor: "#cbe5fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498,
    stopColor: "#d6ebfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.734,
    stopColor: "#eaf4fe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925,
    stopColor: "#fff"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ID1)",
    d: "M20.3 13.8h16.8v29.8H20.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m40 26.1 3.2 3.2c.7.7 1.6 1.1 2.5 1.1 1 0 1.9-.4 2.5-1 .7-.7 1.1-1.6 1.1-2.5 0-1-.4-1.9-1-2.5L41 16.9l-.1-.1-.2-.1-.2-.2c-.1 0-.1-.1-.2-.2s-.2-.1-.3-.2c-.5-.3-1.1-.4-1.7-.4-.6 0-1.2.2-1.7.5-.3.2-.6.3-.8.6l-7.4 7.4c-.8.8-1.2 2-1 3.1-.2 0-.4-.1-.6-.1-1 0-1.9.4-2.5 1.1L21 31.5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m17.6 31.5-3.2-3.2c-.7-.7-1.6-1.1-2.5-1.1-1 0-1.9.4-2.5 1-.7.7-1.1 1.6-1.1 2.5 0 1 .4 1.9 1.1 2.5l7.3 7.3.1.1c.2.2.5.4.8.6.5.3 1.1.5 1.7.5.6 0 1.2-.2 1.7-.5.3-.2.6-.4.8-.6l7.4-7.4c.8-.8 1.2-2 1-3.1.2 0 .4.1.6.1 1 0 1.9-.4 2.5-1.1l3.1-3.1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M35.9 11.3H21.8c-2.3 0-4.2 1.9-4.2 4.2v18.8l-4.5-4.5c-.7-.7-1.8-.7-2.4 0-.7.7-.7 1.8 0 2.4l6.9 6.9.5.5v.1c.3.3.8.5 1.2.5.4 0 .9-.2 1.2-.5l.5-.7 6.9-6.9c.7-.7.7-1.8 0-2.4-.7-.7-1.8-.7-2.4 0L21 34.1V15.4c0-.4.3-.7.8-.7h14.1c.2 0 .4.1.5.2.1.1.2.3.2.5v.7c.5-.3 1.1-.5 1.7-.5.6 0 1.2.2 1.7.4v-.7c0-2.1-1.8-4-4.1-4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m47 25.5-6.9-7-.5-.5-.2-.2-.1-.1c-.1-.1-.2-.1-.2-.1H39c-.1 0-.1 0-.2-.1h-.9c-.1 0-.1 0-.2.1h-.1c-.1 0-.1.1-.2.1 0 0-.1 0-.1.1-.1.1-.2.1-.3.2l-7.4 7.4c-.7.7-.7 1.8 0 2.4.3.3.8.5 1.2.5.4 0 .9-.2 1.2-.5l4.5-4.5V42c0 .4-.3.7-.8.7h-14c-.2 0-.4-.1-.5-.2-.1-.1-.2-.3-.2-.5v-.7c-.5.3-1.1.5-1.7.5-.6 0-1.2-.2-1.7-.5v.7c0 2.3 1.8 4.2 4.1 4.2h14.1c2.3 0 4.2-1.9 4.2-4.2V23.4l4.5 4.5c.3.3.8.5 1.2.5.4 0 .9-.2 1.2-.5.7-.6.7-1.7.1-2.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobiletogether);
export default __webpack_public_path__ + "static/media/mobiletogether.ceecde5a410923dd75847abfc0a0177b.svg";
export { ForwardRef as ReactComponent };